import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const DarkButtonWithIcon = ({ text, onClick, icon, iconPosition = 'end', sx = {}, disabled = false }) => {
    const iconProps = {
        [`${iconPosition}Icon`]: icon
    };

    return (
        <Button
            variant="contained"
            onClick={onClick}
            disabled={disabled}
            {...iconProps}
            sx={{
                backgroundColor: disabled ? '#f5f5f5' : '#000',
                color: disabled ? '#c4c4c4' : '#fff',
                fontWeight: 700,
                borderRadius: '20px',
                textTransform: 'none',
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.7rem',
                border: disabled ? '1px solid #f5f5f5' : '1px solid #000',
                '&:hover': {
                    backgroundColor: disabled ? '#f5f5f5' : '#000',
                    boxShadow: disabled ? 'none' : 2,
                },
                '& .MuiButton-endIcon': {
                    marginLeft: '4px',
                    transform: iconPosition === 'end' ? 'scaleX(-1)' : 'none',
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px'
                    }
                },
                '& .MuiButton-startIcon': {
                    marginRight: '4px',
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px'
                    }
                },
                ...sx
            }}
        >
            {text}
        </Button>
    );
};

DarkButtonWithIcon.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    iconPosition: PropTypes.oneOf(['start', 'end']),
    sx: PropTypes.object,
    disabled: PropTypes.bool
};

export default DarkButtonWithIcon;